export const obfuscateEmail = (email) => {
  if (!email) return '';
  const [local, domain] = email.split('@');
  return `${local[0]}***@${domain}`;
};

export const trackEvent = (event, params = {}) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  const clear = {};
  Object.keys(params).forEach(k => { clear[k] = undefined; });
  if (Object.keys(clear).length > 0) {
    window.dataLayer.push(clear);
  }
};
